import type { AppProps } from "@nuxt/ui/components/App.vue";

// Our tooltips open above their trigger, arrow touching it, after 300ms; Nuxt UI's open 8px below after 700ms.
export const nuxtUiAppProps = {
  tooltip: { delayDuration: 300, content: { side: "top", sideOffset: 0 } },
} as const satisfies AppProps;
